const KEY = "photosynthetic_cookie_consent";
export type ConsentValue = "accepted" | "declined";

export const getConsent = (): ConsentValue | null => {
  if (typeof window === "undefined") return null;
  const v = window.localStorage.getItem(KEY);
  return v === "accepted" || v === "declined" ? v : null;
};

export const setConsent = (value: ConsentValue) => {
  try {
    window.localStorage.setItem(KEY, value);
    window.dispatchEvent(new CustomEvent("cookieconsent:change", { detail: value }));
    try {
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push({ event: "cookie_consent", consent: value });
    } catch {}
    try {
      if ((window as any).clarity) {
        (window as any).clarity("consent", value === "accepted");
      }
    } catch {}
  } catch {}
};

export const openCookieSettings = () => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event("cookieconsent:open"));
};

export const openCookieList = () => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event("cookielist:open"));
};

/** Analytics is on unless the visitor explicitly declined. */
export const isAnalyticsAllowed = () => getConsent() !== "declined";